import { useRootMenu } from '../../queries/ats/layout/queries';
import { Layout } from '../../queries/ats/layout/types';

export function useUnmanagedRoutePath(action: `${Layout.SectionItemAction}`) {
  const { data: path } = useRootMenu({
    select: (data) => {
      const items = data.filter((item): item is Layout.SectionItemUnmanaged => item.type === 'unmanaged');
      return items.find((item) => item.params.action === action)?.slug;
    },
  });

  return path;
}
